let elementName = `nss-buybox-pane`;
if (typeof customElements.get(elementName) === `undefined`) {
  class NSSBuyboxPane extends HTMLElement {
    constructor() {
      super();

      this.debug = false;
    }

    connectedCallback() {
      if (this.debug) console.log(`[NSS][Buybox Pane] Connected.`);

      this.variantId = this.getAttribute(`nss-variant-id`);
      this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
    }

    updateHandler(e) {
      const newId = e.detail.newId;

      const scope =
        this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
      if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
        return;
      }

      if (newId === this.variantId) {
        this.classList.add(`nss-active`);
      } else {
        const planMenu = this.querySelector(`[nss-plan-select]`);
        planMenu?.parentElement.classList.remove(`nss-active`);
        this.classList.remove(`nss-active`);
      }
    }
  }

  customElements.define(elementName, NSSBuyboxPane);
} else {
  console.warn(`[NSS] Element '${elementName}' already defined.`);
}

class NSSBuyboxBottom extends HTMLElement {
  constructor() {
    super();

    this.debug = false;
  }

  connectedCallback() {
    this.variantId = this.getAttribute(`nss-variant-id`);
    this.addEventListener(`buyboxUpdate`, this.updateHandler.bind(this));
  }

  updateHandler(e) {
    const newId = e.detail.newId;

    const scope = this.closest(`nss-buybox`) || this.closest(`[id^="shopify-section"]`) || document;
    if (!scope.querySelector(`[nss-buybox-update][nss-variant-id="${newId}"]`)) {
      return;
    }

    if (newId === this.variantId) {
      this.classList.add(`nss-active`);
    } else {
      this.classList.remove(`nss-active`);
    }
  }
}

let elementName2 = `nss-buybox-bottom`;

if (typeof customElements.get(elementName2) === `undefined`) {
  customElements.define(elementName2, NSSBuyboxBottom);
}
